import joi from 'joi';
import { Alert, FormGroup } from '@mui/material';
import {
  RssComponentAttributes,
  RssComponentI18nAttributes,
  parseRSSFeed,
} from '@loyalty/editor-components';
import { extractErrorMessage } from '@loyalty/shared-common';
import { useFormContext } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { InputTextField } from '../../../../shared/forms/fields/InputTextField';
import { Loader } from '../../../../shared/layout/Loader';
import { Trait } from '../utils/Trait';
import { TraitFormValue } from '../types';

export const rssWidgetTraitsSchema = joi.object<TraitFormValue>({
  i18nAttributes: joi.object<RssComponentI18nAttributes>({
    feedUrl: joi.string().uri(),
  }),
});

type FormValue = TraitFormValue<RssComponentAttributes, RssComponentI18nAttributes>;

export function RSSWidgetTraits() {
  const { t } = useTranslation();
  const { watch } = useFormContext<FormValue>();

  const feedUrl = watch('attributes.feedUrl');
  const i18nFeedUrl = watch('i18nAttributes.feedUrl');

  // TODO add debounce 300ms, though most people paste the URL
  const feed = useQuery({
    queryKey: [i18nFeedUrl],
    queryFn: () => (i18nFeedUrl ? parseRSSFeed(i18nFeedUrl) : undefined),
  });

  return (
    <FormGroup>
      <Trait>
        <InputTextField<FormValue>
          name="i18nAttributes.feedUrl"
          label={t('editor.rss.traits.feed-url.label')}
          placeholder={t('editor.rss.traits.feed-url.placeholder')}
          defaultValue={feedUrl}
        />
      </Trait>
      {feed.isPending ? (
        <Loader />
      ) : feed.error ? (
        <Alert severity="error">
          {t('widgets.rss.errors.feedURL.parse', {
            message: extractErrorMessage(feed.error as Error),
          })}
        </Alert>
      ) : feed.data ? (
        <Alert severity="success">{t('widgets.rss.feedURL.parse.success')}</Alert>
      ) : (
        <></>
      )}
    </FormGroup>
  );
}
